(() => {
  const page = document.querySelector('[data-oe-wishlist-page]');
  if (!page) return;

  const grid = page.querySelector('[data-oe-wishlist-cards]');
  const empty = page.querySelector('[data-oe-wishlist-empty]');
  const login = page.querySelector('[data-oe-wishlist-login]');
  const error = page.querySelector('[data-oe-wishlist-error]');
  const noResults = page.querySelector('[data-oe-wishlist-no-results]');
  const active = page.querySelector('[data-oe-wishlist-active]');
  const chips = page.querySelector('[data-oe-wishlist-chips]');
  const drawer = page.querySelector('[data-oe-wishlist-drawer]');
  const unavailable = page.querySelector('[data-oe-wishlist-unavailable]');
  const forms = [...page.querySelectorAll('[data-oe-wishlist-filter-form]')];
  const idPattern = /^[1-9]\d{0,19}$/;
  const handlePattern = /^[a-z0-9][a-z0-9-]*$/;
  const compare = new Intl.Collator('de', {sensitivity: 'base', numeric: true});
  const state = {kategorie: new Set(), hersteller: new Set(), min: null, max: null, sort: 'recent'};
  let closeFocus = null;
  let priceTimer;

  const cards = () => [...grid.querySelectorAll(':scope > .oe-wishlist-page__item')];
  const cardValue = (node, field) => field === 'kategorie' ? node.dataset.category : node.dataset.vendor;
  const euro = (value) => value == null ? '' : new Intl.NumberFormat('de-DE', {maximumFractionDigits: 2}).format(value);
  const parseEuro = (value) => {
    const cleaned = String(value).replace(/\s|\./g, '').replace(',', '.');
    if (!cleaned) return null;
    const number = Number(cleaned);
    return Number.isFinite(number) && number >= 0 ? number : null;
  };

  function option(label, field, index, form) {
    const row = document.createElement('div');
    row.className = 'oe-filter-value';
    const input = document.createElement('input');
    input.type = 'checkbox';
    input.name = field;
    input.value = label;
    input.id = `Wishlist-${form.dataset.oeWishlistFilterForm}-${field}-${index}`;
    input.checked = state[field].has(label);
    const text = document.createElement('label');
    text.htmlFor = input.id;
    const check = document.createElement('span');
    check.className = 'oe-filter-value__check';
    check.setAttribute('aria-hidden', 'true');
    check.innerHTML = '<svg viewBox="0 0 10 8"><path fill="currentColor" d="M3.5 7.5.5 4.4l1.1-1.1 1.9 2L8.4.4l1.1 1.1z"/></svg>';
    const name = document.createElement('span');
    name.className = 'oe-filter-value__label';
    name.textContent = label;
    text.append(check, name);
    row.append(input, text);
    return row;
  }

  function buildOptions() {
    for (const field of ['kategorie', 'hersteller']) {
      const values = [...new Set(cards().map((node) => cardValue(node, field)).filter(Boolean))].sort(compare.compare);
      state[field] = new Set([...state[field]].filter((value) => values.includes(value)));
      for (const form of forms) {
        const box = form.querySelector(`[data-oe-wishlist-options="${field}"]`);
        const more = form.querySelector(`[data-oe-wishlist-more="${field}"]`);
        const expanded = box.dataset.oeExpanded === 'true';
        box.replaceChildren(...values.map((value, index) => option(value, field, index, form)));
        box.dataset.oeCollapsible = String(values.length > 7);
        box.dataset.oeExpanded = String(expanded);
        more.hidden = values.length <= 7;
        more.textContent = expanded ? 'Weniger anzeigen' : 'Mehr anzeigen';
        more.setAttribute('aria-expanded', String(expanded));
      }
    }
    const prices = cards().map((node) => Number(node.dataset.price) / 100).filter(Number.isFinite);
    const maximum = prices.length ? Math.max(...prices) : 0;
    for (const form of forms) {
      form.querySelector('[data-oe-wishlist-price="min"]').placeholder = '0';
      form.querySelector('[data-oe-wishlist-price="max"]').placeholder = euro(maximum);
    }
  }

  function syncControls(skipPrice = false) {
    for (const form of forms) {
      for (const input of form.querySelectorAll('input[type="checkbox"]')) input.checked = state[input.name].has(input.value);
      if (!skipPrice) {
        form.querySelector('[data-oe-wishlist-price="min"]').value = euro(state.min);
        form.querySelector('[data-oe-wishlist-price="max"]').value = euro(state.max);
      }
    }
    const isActive = state.kategorie.size || state.hersteller.size || state.min != null || state.max != null;
    page.querySelectorAll('[data-oe-wishlist-reset]').forEach((button) => { button.hidden = !isActive; });
    const mobileReset = page.querySelector('.oe-filter-drawer__reset');
    if (mobileReset) mobileReset.nextElementSibling.style.gridColumn = isActive ? '' : '1 / -1';
  }

  function chip(label, onRemove) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'oe-active-filters__chip';
    button.setAttribute('aria-label', `Filter ${label} entfernen`);
    button.append(document.createTextNode(label));
    const cross = document.createElement('span');
    cross.setAttribute('aria-hidden', 'true');
    cross.textContent = '×';
    button.append(cross);
    button.addEventListener('click', onRemove);
    return button;
  }

  function apply(skipPrice = false) {
    let shown = 0;
    for (const node of cards()) {
      const price = Number(node.dataset.price) / 100;
      const visible = (!state.kategorie.size || state.kategorie.has(node.dataset.category)) &&
        (!state.hersteller.size || state.hersteller.has(node.dataset.vendor)) &&
        (state.min == null || price >= state.min) &&
        (state.max == null || price <= state.max);
      node.hidden = !visible;
      if (visible) shown += 1;
    }
    const ordered = cards().sort((a, b) => {
      if (state.sort === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
      if (state.sort === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
      if (state.sort === 'title-asc') return compare.compare(a.dataset.title || '', b.dataset.title || '');
      if (state.sort === 'title-desc') return compare.compare(b.dataset.title || '', a.dataset.title || '');
      return Number(a.dataset.recent) - Number(b.dataset.recent);
    });
    grid.append(...ordered);
    chips.replaceChildren();
    for (const field of ['kategorie', 'hersteller']) {
      for (const value of state[field]) chips.append(chip(value, () => { state[field].delete(value); update(); }));
    }
    if (state.min != null || state.max != null) chips.append(chip(`Preis: ${state.min == null ? '0' : euro(state.min)}–${state.max == null ? '∞' : euro(state.max)} €`, () => { state.min = state.max = null; update(); }));
    active.hidden = chips.childElementCount === 0;
    noResults.hidden = shown > 0 || !cards().length;
    empty.hidden = cards().length > 0 || page.dataset.loaded !== 'true';
    grid.hidden = cards().length === 0;
    syncControls(skipPrice);
  }

  function update() { buildOptions(); apply(); }

  async function fetchLegacyCard(item) {
    if (!idPattern.test(String(item.productId))) return null;
    const wrapper = document.createElement('li');
    wrapper.className = 'grid__item oe-wishlist-page__item';
    wrapper.dataset.productId = String(item.productId);
    if (!handlePattern.test(item.handle || '')) {
      wrapper.append(unavailable.content.firstElementChild.cloneNode(true));
      wrapper.querySelector('[data-oe-wishlist-button]').dataset.productId = String(item.productId);
      return wrapper;
    }
    const url = new URL(`/products/${encodeURIComponent(item.handle)}`, location.origin);
    url.searchParams.set('section_id', 'oe-wishlist-card');
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview && idPattern.test(preview)) url.searchParams.set('preview_theme_id', preview);
    const response = await fetch(url, {credentials: 'same-origin'});
    if (!response.ok) throw new Error('Card unavailable');
    const rendered = new DOMParser().parseFromString(await response.text(), 'text/html');
    const card = rendered.querySelector('.oe-collection-card');
    if (!card) throw new Error('Card unavailable');
    const meta = rendered.querySelector('[data-oe-wishlist-card-meta]');
    wrapper.dataset.category = meta?.dataset.category || 'Weitere Produkte';
    wrapper.dataset.vendor = meta?.dataset.vendor || '';
    wrapper.dataset.price = meta?.dataset.price || '0';
    wrapper.dataset.title = meta?.dataset.title || '';
    wrapper.append(document.importNode(card, true));
    return wrapper;
  }

  function markSaved(node, item) {
    const button = node.querySelector('[data-oe-wishlist-button]');
    if (button) {
      button.setAttribute('aria-pressed', 'true');
      button.setAttribute('aria-label', 'Von Wunschliste entfernen');
      button.title = 'Von Wunschliste entfernen';
    }
    if (item.variantId && idPattern.test(String(item.variantId))) {
      node.querySelectorAll('a[href^="/products/"]').forEach((link) => {
        const url = new URL(link.getAttribute('href'), location.origin);
        url.searchParams.set('variant', String(item.variantId));
        link.href = url.pathname + url.search;
      });
    }
  }

  async function load() {
    try {
      const response = await fetch(page.dataset.endpoint, {credentials: 'same-origin', headers: {Accept: 'application/json'}, cache: 'no-store'});
      if (response.status === 401) { login.hidden = false; grid.hidden = true; return; }
      if (!response.ok) throw new Error('Wishlist unavailable');
      const payload = await response.json();
      if (!Array.isArray(payload.items)) throw new Error('Invalid wishlist');
      const valid = payload.items.filter((item) => idPattern.test(String(item.productId)));
      const expected = new Set(valid.map((item) => String(item.productId)));
      for (const node of cards()) if (!expected.has(node.dataset.productId)) node.remove();
      const missing = valid.filter((item) => !cards().some((node) => node.dataset.productId === String(item.productId)));
      let failures = 0;
      for (let start = 0; start < missing.length; start += 4) {
        const settled = await Promise.allSettled(missing.slice(start, start + 4).map(fetchLegacyCard));
        for (const result of settled) {
          if (result.status === 'fulfilled' && result.value) grid.append(result.value);
          else failures += 1;
        }
      }
      valid.slice().reverse().forEach((item, index) => {
        const node = cards().find((card) => card.dataset.productId === String(item.productId));
        if (node) { node.dataset.recent = String(index); markSaved(node, item); }
      });
      if (failures) error.hidden = false;
      page.dataset.loaded = 'true';
      update();
    } catch (_) { error.hidden = false; }
  }

  function closeDrawer() {
    drawer.hidden = true;
    document.body.classList.remove('oe-filter-drawer-open');
    closeFocus?.focus();
  }
  page.querySelector('[data-oe-wishlist-drawer-open]').addEventListener('click', (event) => {
    closeFocus = event.currentTarget;
    drawer.hidden = false;
    document.body.classList.add('oe-filter-drawer-open');
    page.querySelector('[data-oe-wishlist-drawer-panel]').focus();
  });
  page.querySelectorAll('[data-oe-wishlist-drawer-close]').forEach((button) => button.addEventListener('click', closeDrawer));
  drawer.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeDrawer(); });
  forms.forEach((form) => {
    form.addEventListener('submit', (event) => { event.preventDefault(); closeDrawer(); });
    form.addEventListener('change', (event) => {
      const input = event.target;
      if (input.type === 'checkbox') {
        if (input.checked) state[input.name].add(input.value);
        else state[input.name].delete(input.value);
        apply();
      } else if (input.matches('[data-oe-wishlist-price]')) {
        state[input.dataset.oeWishlistPrice] = parseEuro(input.value);
        apply();
      }
    });
    form.addEventListener('input', (event) => {
      const input = event.target;
      if (!input.matches('[data-oe-wishlist-price]')) return;
      clearTimeout(priceTimer);
      priceTimer = setTimeout(() => {
        state[input.dataset.oeWishlistPrice] = parseEuro(input.value);
        apply(true);
      }, 250);
    });
    form.querySelectorAll('[data-oe-wishlist-more]').forEach((button) => button.addEventListener('click', () => {
      const box = form.querySelector(`[data-oe-wishlist-options="${button.dataset.oeWishlistMore}"]`);
      const expanded = box.dataset.oeExpanded !== 'true';
      box.dataset.oeExpanded = String(expanded);
      button.setAttribute('aria-expanded', String(expanded));
      button.textContent = expanded ? 'Weniger anzeigen' : 'Mehr anzeigen';
    }));
    form.querySelector('[data-oe-wishlist-reset]').addEventListener('click', () => {
      state.kategorie.clear(); state.hersteller.clear(); state.min = state.max = null; update();
    });
  });
  page.querySelectorAll('[data-oe-wishlist-sort]').forEach((select) => select.addEventListener('change', () => {
    state.sort = select.value;
    page.querySelectorAll('[data-oe-wishlist-sort]').forEach((other) => { other.value = state.sort; });
    apply();
  }));
  document.addEventListener('oe:wishlist:changed', (event) => {
    if (event.detail?.saved !== false) return;
    cards().find((node) => node.dataset.productId === String(event.detail.productId))?.remove();
    update();
  });
  cards().forEach((node, index) => { node.dataset.recent = String(index); markSaved(node, {}); });
  update();
  load();
})();
